import { useCMS } from '@/hooks/useCMS';

const DEFAULT = {
  items: [
    'ISO 9001:2015 სერტიფიცირებული',
    'Laminam — ოფიციალური დისტრიბუტორი',
    '25+ წლის გამოცდილება',
    'Ardex — ოფიციალური დისტრიბუტორი',
    '5,000+ დასრულებული პროექტი',
    'Tecnopol — ოფიციალური დისტრიბუტორი',
    '1-3 დღე მიწოდება',
    'Fodbo — ოფიციალური დისტრიბუტორი',
    '100% ხარისხის გარანტია',
    'Dicson — ოფიციალური დისტრიბუტორი',
  ],
};

export default function TrustBadges() {
  const d = useCMS('trust_badges', DEFAULT);
  const items: string[] = d.items || DEFAULT.items;
  const doubled = [...items, ...items];

  return (
    <div className="bg-[#1C1C1C] py-4 overflow-hidden border-y border-white/5">
      <div className="flex gap-12 whitespace-nowrap" style={{ animation: 'marquee 30s linear infinite', width: 'max-content' }}>
        {doubled.map((item, i) => (
          <div key={i} className="flex items-center gap-4 flex-shrink-0">
            <div className="w-1 h-1 rounded-full bg-[#ec3145]"></div>
            <span className="text-[10px] font-bold tracking-[0.25em] uppercase text-white/50">{item}</span>
          </div>
        ))}
      </div>
      <style>{`@keyframes marquee{0%{transform:translateX(0)}100%{transform:translateX(-50%)}}`}</style>
    </div>
  );
}
